export enum RncpProjection {
  DEFAULT = 'DEFAULT',
  AJOUT = 'AJOUT',
}